import { LangEn } from 'assets/locales/en';
import { Language } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';

// Same approach as missionTemplate/templateTexts.js: the qualification screens
// read the locale files directly, in the language Context.js sets for the
// whole admin, so the list row and the pure task helpers can use them too.
const language = new Language();
language.loadLanguage(LangFr);
language.loadLanguage(LangEn);
language.setLanguage('fr');

/** A `qualification.*` text, with its `{name}` placeholders filled in. */
export const qualificationText = (key, values = {}) =>
  Object.keys(values).reduce(
    (text, name) => text.split(`{${name}}`).join(String(values[name])),
    language.getValue(`qualification.${key}`, '')
  );

/** `<key>One` for a count of 1, `<key>Other` otherwise. */
export const qualificationCountText = (key, count, values = {}) =>
  qualificationText(`${key}${count === 1 ? 'One' : 'Other'}`, {
    count,
    ...values,
  });
